import { render, staticRenderFns } from "./SidebarImprovements.vue?vue&type=template&id=9337f4a0&"
import script from "./SidebarImprovements.vue?vue&type=script&lang=js&"
export * from "./SidebarImprovements.vue?vue&type=script&lang=js&"
import style0 from "./SidebarImprovements.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports